import React from 'react'

const ESDSafeBin = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">ESD Lab Setup</a>
                        <i class="fa fa-angle-right"></i>
                        <span>ESD Safe Bin</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/esdsafebin.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>ESD Safe Bin:</h2>
                        <p className="mbot25">
                            <b style={{ textDecoration: "underline", marginRight: '5px' }}>Description:</b>
                            An ESD safe bin is designed to store and
                            transport electronic components and tools in a manner that
                            prevents static electricity from causing damage. These bins
                            are constructed from materials that dissipate static charges
                            and often feature grounding points to ensure safety. They
                            are essential in any ESD-sensitive environment to protect
                            valuable electronic parts from electrostatic discharge.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ESDSafeBin
